import { apiClient } from "../../services/axiosInstance";
import { Archetype, ServerSingleResponse } from "../../types";

export function toggleAccountInterests(
  type: "comic_types" | "comic_genres" | "comic_facets",
  id: number[],
) {
  return apiClient.post<ServerSingleResponse<boolean>>(
    `/v1/account/interests/${type.replace("_", "-")}/update`,
    { payload: { id }, meta: [] },
  );
}

export function setUserArchetype(slug: string) {
  return apiClient.post<ServerSingleResponse<Archetype>>(
    `/v1/account/interests/archetype/${slug}`,
    { payload: {}, meta: [] },
  );
}

export function clearUserArchetype() {
  return apiClient.post<ServerSingleResponse<Record<string, never>>>(
    `/v1/account/interests/archetype/clear`,
    { payload: {}, meta: [] },
  );
}
